import { render, staticRenderFns } from "./NotificationsToast.vue?vue&type=template&id=735b3854&scoped=true&"
import script from "./NotificationsToast.vue?vue&type=script&lang=js&"
export * from "./NotificationsToast.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735b3854",
  null
  
)

export default component.exports